import React, { useMemo, useState } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";

import FootprintDatePicker from "../../../Components/utils/FootprintDatePicker";
import FootprintButton from "../../../Components/utils/FootprintInputButton";
import SpinnerLoading from "../../../Components/utils/SpinnerLoading";
import { FaAngleDown } from "react-icons/fa";
import { useRequestProcessor } from "../../../requestProcessor";
import {
  fetchCentersShift,
  fetchProgram,
  handleShiftCenter,
} from "../../../QueryFunctions/queryfunction";
import { mobileAtom } from "../../../AtomStore/store";
import { getActiveChild } from "../../../AtomStore/ServiceAtoms";

import { StyledCardHeader, StyledInput, StyledLink } from "./styles";
import { DEFAULT_FORMAT } from "../../../Components/utils/FootprintDatePicker";

const ShiftCenter = () => {
  const { useMutationWrapper, useQueryWrapper } = useRequestProcessor();

  const [attritionDate, setAttritionDate] = useState();
  const [joiningDate, setJoiningDate] = useState();
  const [selectedCenter, setSelectedCenter] = useState();
  const [selectedProgram, setSelectedProgram] = useState();
  const [holidaySelected, setHolidaySelected] = useState();
  const [centerPrograms, setProgram] = useState();
  const [error, setError] = useState();

  const activeChild = getActiveChild();
  const navigate = useNavigate();

  useMemo(() => {
    console.log(
      "[Shift Center] Initializing Shift form  for child:",
      activeChild?.id
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { data: Centers, isLoading } = useQueryWrapper(
    ["Centers", "centers" + activeChild?.id],
    () => {
      console.log("[Shift Center] Calling API: /parentapp/getCenterJSON ", {
        child_id: activeChild?.id,
      });
      return fetchCentersShift();
    },
    {
      onSuccess: (data) => {
        console.log("[Shift Center] Received Centers:", data);

        const prog = data.find((obj) => {
          const centerData = JSON.parse(obj.value);
          return centerData.Center_Id === activeChild?.center_id?.toString();
        });

        if (prog) {
          const programsAvailable = JSON.parse(prog.value).Programs_Available;
          setProgram(programsAvailable.split(","));
        } else {
          console.log("No center found for the given Center_Id.");
        }
      },
    }
  );

  console.log("center prorgams", centerPrograms);

  const { data: Program } = useQueryWrapper(
    ["program"],
    () => {
      console.log("[Shift Center] Calling API:Fetch Program");
      return fetchProgram();
    },
    {
      onSuccess: (data) => {
        console.log("[Shift Center] Received Programs:", data);
      },
    }
  );

  const shiftCenter = useMutationWrapper(
    ["shiftCenter", "shift" + activeChild?.id],
    () => {
      console.log("[Shift Center] Calling API: /parentapp/request ", {
        joiningDate,
        attritionDate,
        selectedCenter,
        selectedProgram,
      });

      return handleShiftCenter(
        joiningDate,
        attritionDate,
        selectedCenter,
        selectedProgram,
        navigate
      );
    },
    {
      onSuccess: (data) => {
        console.log("[Shift Center] Shift Center Response:", data);
      },
    }
  );

  const validate = () => {
    if (holidaySelected === true) {
      setError("The selected Date Cannot Be a Holiday");

      return false;
    } else if (attritionDate === undefined) {
      setError("Please Select Joining Date");

      return false;
    } else if (joiningDate === undefined) {
      setError("Please Select Attrition Date");

      return false;
    } else if (selectedCenter === undefined || selectedCenter === "") {
      setError("Please Select Center");

      return false;
    } else if (selectedProgram === undefined || selectedProgram === "") {
      setError("Please Select Program");

      return false;
    } else {
      return true;
    }
  };

  const submit = () => {
    if (validate()) {
      shiftCenter.mutate();
    }
  };
  console.log("Selected Center", selectedCenter);

  return (
    <div className="m-[10px] mt-[20px]">
      {(isLoading || shiftCenter.isLoading) && <SpinnerLoading />}

      <div className="bg-white rounded-lg shadow-md p-2">
        <form className="md:p-4 space-y-4 pb-4">
          <div className="grid grid-cols-2">
            {/* Old Center Attrition Date */}
            <div className="border-r">
              <label className="block text-sm font-medium text-black mb-2">
                Old Center Attrition Date
              </label>
              <div className="flex items-center">
                <FootprintDatePicker
                  disableWeekends={true}
                  holidaySelected={(selected) => {
                    setError("The selected Date Cannot Be a Holiday");
                    setHolidaySelected(selected);
                  }}
                  minimumDate={moment()}
                  inputProps={{
                    placeholder: "Select Date",
                  }}
                  defaultDate={attritionDate}
                  onChange={(date) => {
                    setError(undefined);
                    setHolidaySelected(false);
                    setAttritionDate(moment(date).format(DEFAULT_FORMAT));
                  }}
                />
                {/* <i className="icon-calender text-2xl text-black" /> */}
              </div>
            </div>

            {/* New Center Joining Date */}
            <div>
              <label className="block text-sm font-medium text-black mb-2 text-right">
                New Center Joining Date
              </label>
              <div className="flex items-center right-align">
                {/* <i className="icon-calender text-2xl text-black" /> */}

                <FootprintDatePicker
                  disableCalendarOpen={attritionDate ? false : true}
                  disableWeekends={true}
                  holidaySelected={(selected) => {
                    setError("The selected Date Cannot Be a Holiday");
                    setHolidaySelected(selected);
                  }}
                  minimumDate={
                    attritionDate
                      ? new Date(attritionDate).getTime() +
                        1000 * 60 * 60 * 24 * 2
                      : undefined
                  }
                  maximumDate={
                    attritionDate
                      ? new Date(attritionDate).getTime() +
                        1000 * 60 * 60 * 24 * 8
                      : undefined
                  }
                  inputProps={{
                    placeholder: "Select date",
                    // disabled: !attritionDate,
                    textAlign: "right",
                    onClick: (e) => {
                      e.preventDefault();
                      console.log("running jbdfjsdfjd");
                      setError("Please select a start date first.");
                    },
                  }}
                  disabled={true}
                  defaultDate={joiningDate}
                  onChange={(date) => {
                    setError(undefined);
                    setHolidaySelected(false);
                    setJoiningDate(moment(date).format(DEFAULT_FORMAT));
                  }}
                />
              </div>
            </div>
          </div>

          <hr className=" mx-2 mt-2  bg-black" />

          {/* Shift To */}
          <div className="">
            <label className="block text-sm font-medium text-black mb-2">
              Shift To
            </label>
            <div className="rounded-sm relative ">
              <select
                className="w-full  appearance-none pb-1 bg-white"
                onChange={(e) => {
                  setSelectedCenter(JSON.parse(e.target.value));
                  setError(undefined);
                }}
                value={selectedCenter ? JSON.stringify(selectedCenter) : ""}
              >
                <option value="" hidden>
                  Select Center
                </option>
                {Centers?.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
              <FaAngleDown className="pointer-events-none absolute inset-y-0  right-4 flex items-center text-xl " />
            </div>
          </div>
          <hr className=" mx-2 mt-2  bg-black" />

          {/* Program To */}
          <div>
            <label className="block text-sm font-medium text-black mb-2">
              Program To
            </label>
            <div className="relative rounded-sm ">
              <select
                className="w-full  appearance-none bg-white"
                onChange={(e) => {
                  setSelectedProgram(e.target.value);
                  setError(undefined);
                }}
                value={selectedProgram || ""}
              >
                <option value="" hidden>
                  Select Program
                </option>
                {Program?.filter((program) =>
                  centerPrograms?.includes(program.value)
                )?.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.label}
                  </option>
                ))}
              </select>
              <FaAngleDown className="pointer-events-none absolute inset-y-0  right-4 flex items-center text-xl " />
            </div>
          </div>

          {/* Fee Card Link */}
          {selectedCenter?.Center_Feecard && (
            <div className="text-center">
              <StyledLink
                className="text-header"
                href={selectedCenter.Center_Feecard}
              >
                View Fee Details
              </StyledLink>
            </div>
          )}

          {/* Error Message */}
          {error && <div className="text-red-500 text-sm">{error}</div>}

          {/* Submit Button */}
          <div className="text-center">
            <FootprintButton
              className="bg-primary text-white px-6 py-2 rounded-md hover:bg-primary-dark"
              onClick={submit}
            >
              Submit
            </FootprintButton>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ShiftCenter;
